module.exports = __webpack_public_path__ + "static/media/01.901b7f61.jpg";